export default (time) => {
	const hourTime = time.split(" ")
	const yearsTime = hourTime[0].split("/").reverse().join("-")
	const chinaTime = [yearsTime, hourTime[1]].join(" ")
	return chinaTime
}
